import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import { organizationUnits } from '../../../../../../redux/organizationUnits/action';
import { selectOrganizationUnitsListItems } from '../../../../../../redux/organizationUnits/selector';
import FulfillmentProviderComponent from '../components/fulfillment-provider.component';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { stores } from '../../../../../../redux/stores/action';
import { selectWarehousesListItems } from '../../../../../../redux/ware-houses/selector';
import { warehouses } from '../../../../../../redux/ware-houses/action';
import { fulfillmentProviders } from '../../../../../../redux/fulfillment-providers/action';
import { selectFulfillmentProvidersQueryItems } from '../../../../../../redux/fulfillment-providers/selector';

const ManagementFulfillmentProvider = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const fulfillmentProviderQuery = useSelector(selectFulfillmentProvidersQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
  const storeItems = useSelector(selectStoresListItems)
  const warehouseItems = useSelector(selectWarehousesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const organizationUnitsItems = useSelector(selectOrganizationUnitsListItems)

  const [
    selectFulfillmentProvider,
    setSelectFulfillmentProvider
  ] = useState<any>([])

  const fetchFulfillmentProvidersQueryById = () => {
    dispatch(fulfillmentProviders.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers/query`, entity: 'fulfillmentProviders', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }
    setSelectFulfillmentProvider({ ...selectFulfillmentProvider, [fields[0]]: value });
  }

  useEffect(
    () => {
      dispatch(organizationUnits.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {}
      })).then(() => {
        dispatch(stores.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`, entity: 'stores', jsonData: {}
        }))
      }).then(() => {
        dispatch(warehouses.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`, entity: 'warehouses', jsonData: {

          }
        }))
      }).then(() => {
        if (parmas?.id > 0) {
          fetchFulfillmentProvidersQueryById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectFulfillmentProvider(
          {
            Login: fulfillmentProviderQuery?.result?.items?.Login,
            UserProfile: fulfillmentProviderQuery?.result?.items?.UserProfile,
            Account: {
              IsPersonAccount: fulfillmentProviderQuery?.result?.items?.Account?.IsPersonAccount,
              Name: fulfillmentProviderQuery?.result?.items?.Account?.Name,
              NumberOfEmployees: fulfillmentProviderQuery?.result?.items?.Account?.NumberOfEmployees,
              DisplayOrder: fulfillmentProviderQuery?.result?.items?.Account?.DisplayOrder,
              IsInternalProvider: fulfillmentProviderQuery?.result?.items?.Account?.IsInternalProvider,
              IsActive: fulfillmentProviderQuery?.result?.items?.Account?.IsActive,
              APIKey: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.APIKey,
              APISecret: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.APISecret,
              UserName: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.UserName,
              Password: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.Password,
              StoreId: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.StoreId,
              WarehouseId: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.WarehouseId,
              FullfillmentMethodId: fulfillmentProviderQuery?.result?.items?.Account?.Configuration?.FullfillmentMethodId

            },
            PrimaryAddress: fulfillmentProviderQuery?.result?.items?.PrimaryAddress,
            LimitedToOrganizationMappings: fulfillmentProviderQuery?.result?.items?.LimitedToOrganizationMappings
          }
        )
      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    const fulfillmentProviderData = {

      Login: selectFulfillmentProvider?.Login,
      UserProfile: selectFulfillmentProvider?.UserProfile,
      Account: {
        IsPersonAccount: selectFulfillmentProvider?.Account?.IsPersonAccount,
        Name: selectFulfillmentProvider?.Account?.Name,
        NumberOfEmployees: selectFulfillmentProvider?.Account?.NumberOfEmployees,
        DisplayOrder: selectFulfillmentProvider?.Account?.DisplayOrder,
        IsInternalProvider: selectFulfillmentProvider?.Account?.IsInternalProvider,
        IsActive: selectFulfillmentProvider?.Account?.IsActive,
        Configuration: {
          APIKey: selectFulfillmentProvider?.Account?.APIKey,
          APISecret: selectFulfillmentProvider?.Account?.APISecret,
          UserName: selectFulfillmentProvider?.Account?.UserName,
          Password: selectFulfillmentProvider?.Account?.Password,
          StoreId: selectFulfillmentProvider?.Account?.StoreId,
          WarehouseId: selectFulfillmentProvider?.Account?.WarehouseId,
          FullfillmentMethodId: selectFulfillmentProvider?.Account?.FullfillmentMethodId
        }
      },
      PrimaryAddress: selectFulfillmentProvider?.PrimaryAddress,
      LimitedToOrganizationMappings: selectFulfillmentProvider?.LimitedToOrganizationMappings
    }

    if (parmas?.id > 0) {
      await dispatch(fulfillmentProviders.resetAction({ actionType: 'update' }))
      await dispatch(fulfillmentProviders.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers`, entity: 'fulfillmentProviders', jsonData: {

          Records: [
            fulfillmentProviderData
          ]

        }
      })).then(() => {
        back()
      })
    } else if (selectFulfillmentProvider?.Login?.Password === selectFulfillmentProvider?.Login?.ConfirmPassword) {
      await dispatch(fulfillmentProviders.resetAction({ actionType: 'create' }))
      await dispatch(fulfillmentProviders.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/fullfillment/fulfillment-providers`, entity: 'fulfillmentProviders', jsonData: {

          Records: [
            fulfillmentProviderData
          ]

        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/configuration/fulfillment/fulfillment-providers')
  }
  return (
    <>

      {isLoading ? <PageLoader /> :
        <FulfillmentProviderComponent
          id={parmas?.id}
          stores={storeItems?.result?.items}
          fullfillmentMethods={librariesItems?.FullfillmentMethods}
          selectFulfillmentProvider={selectFulfillmentProvider}
          warehouses={warehouseItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onInnerFormChange={handleInnerFormChange}
          organizationUnits={organizationUnitsItems?.result?.items}
        />
      }
    </>
  )

}

export default ManagementFulfillmentProvider;